import React from "react";
import { Grid } from "@mui/material";
import BookingManager from "./BookingManager";
import { BookingDataProvider } from "./useBookingData";

const CANcalendar = () => {
    return (
        <BookingDataProvider>
            <Grid
                container
                style={{
                    width: "100vw",
                    height: "100vh",
                    padding: 0,
                    margin: 0,
                }}
            >
                <BookingManager />
            </Grid>
        </BookingDataProvider>
    );
};

export default CANcalendar;
